import React from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import styled from "styled-components";
import html2canvas from "html2canvas";

import {
  mapDispatchToProps,
  mapStateToProps,
  auditTrailCommentReducer,
} from "./AuditTrailComment.store";

import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import AuditTrailComment from "../../library/AuditTrailComment/AuditTrailComment";
import CustomModal, {
  ModalSize,
} from "../../ui-library/CustomModal/CustomModal";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import { useTranslation } from "react-i18next";

const CommentWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  left: 25px;
  z-index: 9999999999;
`;

const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export const SmartAuditTrailComment = (props) => {
  const {
    username,
    screenshot,
    setScreenshot,
    commentModalShow,
    setCommentModalShow,
    submissionError,
    setSubmissionError,
    saveAuditTrailComment,
    canCreateAuditTrailComment,
    route: {
      computedMatch: {
        params: { participantId },
      },
    },
  } = props;

  const { t } = useTranslation();

  const takeScreenShot = () => {
    const appElement = document.getElementsByClassName("App")[0];
    appElement?.classList?.add("no-animation");

    html2canvas(document.body).then((canvas) => {
      const base64 = canvas.toDataURL("image/png");
      const tmpScreenshot = {
        base64: base64,
        file: dataURLtoFile(base64, "auditcomment.png"),
      };
      setScreenshot(tmpScreenshot);
      setCommentModalShow(true);
    });
  };

  const onCloseAuditTrailModal = () => {
    setCommentModalShow(false);
  };

  const onSubmit = (comments) => {
    const formData = new FormData();
    formData.append("comment", comments);
    if (participantId) {
      formData.append("participantID", participantId);
    }
    formData.append("screenshotFile", screenshot.file, screenshot.file.name);

    saveAuditTrailComment(formData)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        onCloseAuditTrailModal();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
        setSubmissionError(true);
      });
  };

  return (
    <>
      {canCreateAuditTrailComment ? (
        <>
          <CommentWrapper>
            <PrimaryButton
              data-testid="take-screenshot"
              className="float-start"
              onClick={(e) => {
                e.preventDefault();
                takeScreenShot();
              }}
            >
              {t("appText.auditTrailComment.comment")}
            </PrimaryButton>
          </CommentWrapper>
          <CustomModal
            show={commentModalShow}
            title={t("appText.auditTrailComment.comment")}
            size={ModalSize.large}
            onClose={() => onCloseAuditTrailModal()}
          >
            <AuditTrailComment
              participantId={username}
              screenshot={screenshot}
              onCancelClick={onCloseAuditTrailModal}
              onSubmit={onSubmit}
              submissionError={submissionError}
              setSubmissionError={setSubmissionError}
            />
          </CustomModal>
        </>
      ) : null}
    </>
  );
};

export default dynamic(
  "auditTrailCommentReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => ({
      loginReducer: state.loginReducer,
      smartPageHeaderReducer: state.smartPageHeaderReducer,
    }),
  }),
  attachReducer(auditTrailCommentReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartAuditTrailComment));
